// ── VerifiedBadge.jsx ───────────────────────────────────────────────────────
// مكوّن شارة التوثيق الاحترافية — تُعرض بجانب اسم الحساب الموثق
// على مستوى الموقع بالكامل (Navbar, EditProfile, ... إلخ)

import React, { useState, useRef, useEffect } from "react";
import "./VerifiedBadge.css";

/**
 * VerifiedBadge — شارة توثيق احترافية
 *
 * Props:
 *   size     — حجم الأيقونة بالـ px (افتراضي: 16)
 *   showTip  — هل تظهر tooltip عند التحويم؟ (افتراضي: true)
 *   isAr     — هل الواجهة عربية؟ (افتراضي: false)
 *   className — CSS class إضافي
 */
const VerifiedBadge = ({ size = 16, showTip = true, isAr = false, className = "" }) => {
  const [tipVisible, setTipVisible] = useState(false);
  const timerRef = useRef(null);

  const label = isAr ? "حساب موثق" : "Verified Account";
  const tip   = isAr
    ? "هذا الحساب موثق من فريق Leaks Mercy"
    : "This account is verified by Leaks Mercy";

  const handleEnter = () => {
    if (!showTip) return;
    timerRef.current = setTimeout(() => setTipVisible(true), 120);
  };
  const handleLeave = () => {
    clearTimeout(timerRef.current);
    setTipVisible(false);
  };

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <span
      className={`vb-root ${className}`}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      onFocus={handleEnter}
      onBlur={handleLeave}
      aria-label={label}
      title={!showTip ? label : undefined}
      role="img"
    >
      {/* SVG shield-check icon — تصميم خاص متناسق */}
      <svg
        className="vb-icon"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
      >
        {/* الدرع الخارجي */}
        <path
          d="M10 2L3.5 4.8V9.6C3.5 13.44 6.26 17.02 10 18C13.74 17.02 16.5 13.44 16.5 9.6V4.8L10 2Z"
          fill="url(#vb-grad)"
          opacity="0.95"
        />
        {/* الدرع الداخلي (ظل) */}
        <path
          d="M10 3.3L4.6 5.76V9.6C4.6 12.94 6.98 16.04 10 16.9C13.02 16.04 15.4 12.94 15.4 9.6V5.76L10 3.3Z"
          fill="url(#vb-grad2)"
          opacity="0.3"
        />
        {/* علامة الصح */}
        <path
          d="M7.2 10.1L9 11.9L13 7.8"
          stroke="#fff"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* التدرج الأساسي */}
        <defs>
          <linearGradient id="vb-grad" x1="3.5" y1="2" x2="16.5" y2="18" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#00c6ff" />
            <stop offset="100%" stopColor="#0072ff" />
          </linearGradient>
          <linearGradient id="vb-grad2" x1="4.6" y1="3.3" x2="15.4" y2="16.9" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#a0d4ff" />
          </linearGradient>
        </defs>
      </svg>

      {/* Tooltip */}
      {showTip && tipVisible && (
        <span className={`vb-tooltip ${isAr ? "vb-tooltip--rtl" : ""}`} role="tooltip">
          <span className="vb-tooltip-inner">
            <svg width="11" height="11" viewBox="0 0 20 20" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
              <path d="M10 2L3.5 4.8V9.6C3.5 13.44 6.26 17.02 10 18C13.74 17.02 16.5 13.44 16.5 9.6V4.8L10 2Z" fill="#00c6ff" />
              <path d="M7.2 10.1L9 11.9L13 7.8" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {tip}
          </span>
          <span className="vb-tooltip-arrow" />
        </span>
      )}
    </span>
  );
};

export default VerifiedBadge;
